
/**
 * Class to declare constants pertaining to the Velocity Widget
 */
export class VelocityConstants {
    public static readonly featureName: string = "VelocityWidget";
    public static readonly queryResult: string = "AggregationResult";
};